import gql from 'graphql-tag';

export const markBackgroundTasksSeenMutation = gql`
  mutation MarkBackgroundTasksSeen($ids: [ID!]!) {
    markBackgroundTasksSeen(ids: $ids)
  }
`;
